<template>
  <div class="nav-box">
    <div class="nav">
      <div class="nav_center">
        <div class="left">
          <img src="../assets/jynav/logo.png" alt="">
        </div>
        <div class="right">
          <template v-if="navlistShow">
            <div class="pc-nav" @click="changeNav(item)"
              :class="{ 'right-item': true, 'active': currentPath === item.src }" v-for="(item) in navList"
              :key="item.id">
              {{ item.title }}</div>
          </template>
          <div class="mobile-nav">
            <van-icon name="apps-o" size="30px" @click="menuBtn" />
          </div>
          <el-dropdown class="new">
            <span class="el-dropdown-link" style="font-size: 20px;color:black;">
              用户中心<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="text-align: center;">{{ $store.state.userInfo.mobile ? $store.state.nickname
                : ''
              }}</el-dropdown-item>
              <el-dropdown-item style="text-align: center;" v-if="!$store.state.userInfo.mobile"
                @click.native="openDialog(1)">登录</el-dropdown-item>
              <el-dropdown-item style="text-align: center;" @click.native="qiutConfirm">退出</el-dropdown-item>
              <el-dropdown-item style="text-align: center;" @click.native="goUserCenter">
                后台管理
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- 移动端导航菜单 -->
      <van-popup @close="popupClose" v-model="$store.state.navpopupShow" position="right" round
        :style="{ height: '26%' }">
        <div class="navMenu-box">
          <div class="navMenu-item" v-for="(item, index) in navTextList" :key="index" @click="NavClick(item.src)"
            :class="{ 'active': currentMobilePath === item.src }">
            {{ item.text }}
          </div>
        </div>
      </van-popup>
    </div>
    <el-dialog :title="flag ? '登录' : '注册'" :visible="centerDialogVisible" width="34%" center
      @close="centerDialogVisible = false" :modal="false">
      <el-form :model="form" :rules="rules" ref="formRef">
        <el-form-item prop="mobile">
          <el-input placeholder="请输入您的手机号" v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" show-password placeholder="请输入您的密码" v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item v-if="!flag" prop="requirePassword">
          <el-input show-password placeholder="请您确认密码" v-model="form.requirePassword"></el-input>
        </el-form-item>
        <el-form-item v-if="!flag" prop="name">
          <el-input placeholder="请输入真实姓名" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item v-if="!flag" prop="code">
          <el-input placeholder="请输入身份证号码" v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item prop="checked">
          <el-checkbox style="margin-bottom: 0;" v-model="form.checked">我已阅读同意
          </el-checkbox>
          <span style="color: #3669ff;" @click="agreementFn(1)">《安略网络用户协议》</span>
          <span style="color: #3669ff;" @click="agreementFn(2)">《安略网络用户隐私政策》</span>
        </el-form-item>
        <el-form-item>
          <div style="width: 100%; text-align: center;">
            <el-button style="width: 100%;" type="primary" @click="submit">{{ flag ? '登录' : '注册' }}</el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <div style="width: 100%;text-align: center;cursor: pointer;">
            {{ flag ? '暂无账号，去申请' : '已有账号，去' }} <span style="color: #5fadff;" @click="gotoRegister">{{ flag ? '注册' : '登录'
              }}</span>?
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 注册提示 -->
    <el-dialog title="温馨提示" :visible.sync="registerVisible" width="50%" center :modal="false">
      <div class="registerVisible">
        感谢您使用安略网络的服务！<br>
        在您使用安略网络服务时，我们将需要收集您的手机号码、邮箱、身份证号码，以用于为您提供安略网络注册、登录和依照法规进行实名认证。收集您的IP地址，个人常用设备信息，以用于为您提供服务。当您使用某些特定服务时，您有可能还需向我们提供其他相关信息，在收集前，我们会另有提示~
        <div class="textBox">
          <div>点击“同意”，即表示您已阅读并充分理解：</div>
          <div><span style="color: #3669ff;" @click="agreementFn(1)">《安略网络用户协议》</span> <span
              style="color: #ff0000;">用户协议内容有更新，请及时查看！</span></div>
          <div><span style="color: #3669ff;" @click="agreementFn(2)">《安略网络用户隐私政策》</span> <span
              style="color: #ff0000;">隐私政策内容有更新，请及时查看！</span></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="registerVisible = false">取 消</el-button>
        <el-button type="primary" @click="registerVisibleSubmit">同意</el-button>
      </span>
    </el-dialog>

    <!-- 用户协议 -->
    <el-dialog :title="currentAgree == 1 ? '安略网络用户服务协议' : '安略网络用户隐私政策'" :visible.sync="agreementVisible" width="60%"
      center :modal="false">
      <el-scrollbar style="height:400px">
        协议须知：<br>
        <agreementText v-if="currentAgree == 1"></agreementText>
        <policyText v-if="currentAgree == 2"></policyText>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreementSubmit">已读</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import agreementText from './agreement.vue'
import policyText from './policy.vue'
import { mapState } from 'vuex'
import { login, registerApi, userInfoApi } from '../api/index'
export default {
  props: {
    navList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const passValidator = (rule, value, callback) => {
      if (value === this.form.password) {
        callback()
      } else {
        callback(new Error('两次输入密码不一致!'))
      }
    }
    const checkedValidator = (rule, value, callback) => {
      if (this.form.checked === true) {
        callback()
      } else {
        callback(new Error('请勾选用户协议'))
      }
    }
    return {
      form: {
        mobile: '',
        password: '',
        requirePassword: '',
        name: '',
        code: '',
        checked: false
      },
      formRef: null,
      flag: true,
      currentAgree: 1,
      centerDialogVisible: false,
      registerVisible: false,
      agreementVisible: false,
      currentPath: '',
      // 新增：移动端当前路径
      currentMobilePath: '',
      windowWidth: document.documentElement.clientWidth,
      navlistShow: true,
      timer: null,
      navTextList: [
        {
          text: '首页',
          src: '/home'
        },
        {
          text: '任务中心',
          src: '/display'
        },
        {
          text: '联系我们',
          src: '/contact'
        }
      ],
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        requirePassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: passValidator, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确身份证号', trigger: 'blur' }
        ],
        checked: [
          { validator: checkedValidator, trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    agreementText,
    policyText
  },
  methods: {
    async getNickname() {
      const res = await userInfoApi({})
      this.$store.commit('setNickname', res.data.data.nickname)
    },
    goUserCenter() {
      if (!this.$store.state.userInfo.id) return this.$message({
        message: '请您登陆！',
        type: 'warning'
      })
      this.$router.push("/userCenter")
    },
    orderFn() {
      this.$router.push({
        path: '/display',
        query: {
          id: 1,
        }
      });
    },
    gotoPublic() {
      this.$router.push('/publish')
    },
    agreementFn(value) {
      this.currentAgree = value
      this.agreementVisible = true
    },
    agreementSubmit() {
      this.agreementVisible = false
    },
    registerVisibleSubmit() {
      this.registerVisible = false
      this.flag = !this.flag
    },
    gotoRegister() {
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
        this.form = {
          mobile: '',
          password: '',
          requirePassword: '',
          name: '',
          code: '',
          checked: false
        }
      })
      if (!this.flag) {
        this.flag = !this.flag
        return
      }
      this.registerVisible = true
    },
    openDialog(value) {
      if (this.$store.state.userInfo.mobile) return this.$message('您已登陆')
      this.centerDialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
        this.form = {
          mobile: '',
          password: '',
          requirePassword: '',
          name: '',
          code: '',
          checked: false
        }
      })
      if (value) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    async submit() {
      await this.$refs.formRef.validate()
      if (this.flag) {
        const res = await login({
          mobile: this.form.mobile,
          password: this.form.password
        })
        if (res.data.code !== 200) {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
          return
        }
        this.$store.commit('setUserInfo', res.data.data)
        this.getNickname()
        this.centerDialogVisible = false
        this.$message({
          message: '登录成功',
          type: 'success'
        })
      } else {
        const res = await registerApi({
          mobile: this.form.mobile,
          password: this.form.password,
          name: this.form.name,
          idcard: this.form.code
        })
        if (res.data.code !== 200) {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
          return
        }
        this.flag = !this.flag
        this.$message({
          message: '注册成功',
          type: 'success'
        })
        this.$nextTick(() => {
          this.$refs.formRef.clearValidate()
          this.form = {
            mobile: '',
            password: '',
            requirePassword: '',
            name: '',
            code: '',
            checked: false
          }
        })
      }
    },
    qiutConfirm() {
      if (!this.$store.state.userInfo.mobile) return this.$message('暂未登录')
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setQuit')
        this.$message({
          type: 'success',
          message: '退出成功!'
        })
        this.$router.push('/home')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    NavClick(src) {
      this.$store.commit('setNavpopupShow', false)
      // 新增：更新移动端当前路径
      this.currentMobilePath = src;
      this.$router.push(src)
    },
    changeNav(item) {
      this.$router.push(item.src)
    },
    menuBtn() {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.$store.commit('setNavpopupShow', true)
      this.$store.commit('setIndex', -1)
    },
    popupClose() {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.$store.commit('setIndex', 0)
      }, 2000)
    }
  },
  mounted() {
  },
  watch: {
    windowWidth(newVal, oldVal) {
      console.log('new', 'old')
    },
    // 监听路由变化
    '$route.path': function (newVal, oldVal) {
      this.currentPath = newVal
      // 新增：同步更新移动端路径
      this.currentMobilePath = newVal;
    }
  },
  created() {
    console.log('document.documentElement.clientWidth', document.documentElement.clientWidth)
    console.log(this.$route.fullPath)
    // 新增：初始化当前路径
    this.currentPath = this.$route.path;
    this.currentMobilePath = this.$route.path;
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

// 移动端
@media (max-width: 992px) {
  .navMenu-box {
    text-align: center;
    padding: 0 20px;
    font-size: 15px;

    .navMenu-item {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid rgba(135, 135, 135, 0.2);

      // 新增：移动端高亮样式
      &.active {
        color: #ff8714;
        font-weight: bold;
        background-color: rgba(255, 135, 20, 0.1);
      }
    }
  }

  .nav-box {
    position: fixed;
    z-index: 999999;
    width: 100% !important;

    .nav {
      display: flex;
      padding: 0 20px;
      height: 51px;
      width: 100% !important;
      justify-content: space-between;

      .left {
        width: 100px;
        height: 50px;
        line-height: 50px;

        img {
          width: 100%;
        }
      }
    }
  }

  .right {
    line-height: 65px;

    .new {
      display: none;
    }
  }

  .pc-nav {
    display: none;
  }

  .mobile-nav {
    display: block;
  }
}

// pc端
.registerVisible {
  .textBox {
    margin-top: 10px;
    margin-left: 50px;

    div:nth-child(2) {
      margin: 10px 0;
    }
  }
}

.pc-nav {
  display: block;
}

.mobile-nav {
  display: none;
}

.nav-box {
  width: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  z-index: 999;

  .nav {
    padding: 0 50px;
    height: 75px;
    width: 100%;

    .nav_center {
      display: flex;
      width: 1400px;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      color: black;
      font-size: 20px;

      .left {
        margin-right: 238px;

        span {
          cursor: pointer;
        }

        img {
          width: 173px;
          height: 40px;
        }
      }

      .right {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
      }
    }

    .right-item {
      position: relative;
      padding: 15px;
      cursor: pointer;
      margin-right: 60px;

      // 启用高亮样式
      &.active {
        color: #3669ff;

        &::before {
          content: ' ';
          display: flex;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 3px;
          width: 40%;
          height: 4px;
          background-color: #3669ff;
        }
      }
    }
  }
}
</style>